import FirstToContact from "@forwardflow/components/Campaign/FirstToContact";

const FirstToContactPage = () => {
  return (
    <>
      <FirstToContact />
    </>
  );
};

export default FirstToContactPage;
